import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'doktar-picker',
  templateUrl: './custom-picker.component.html',
  styleUrls: ['./custom-picker.component.scss'],
})
export class CustomPickerComponent implements OnInit, AfterViewInit {
  @Input() list: Array<any>;
  @Input() id: string;
  @Input() index: number = 1;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  first = false;
  public scroll = false;
  private timeout: any;
  constructor() { }
  ngAfterViewInit(): void {
    var that = this;
    setTimeout(() => {
      var header = document.getElementById('scroll-div-' + that.id);
      header.scrollTo({
        top: (that.index - 1) * 41,
        behavior: 'auto'
      });
      this.setScroll();
    }, 100);
  }

  ngOnInit() {

  }



  onScroll(ev?) {
    this.scroll = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scroll = false;
      this.onChange.emit(this.index);
    }, 300);
    this.setScroll(ev);
  }
  // isScroolEnd: boolean = null;
  timer: any = null;
  timer2: any = null;
  setScroll(ev?) {

    var that = this;
    // this.isScroolEnd = false;

    if (!this.timer) {
      this.timer = setInterval(function () {
        // that.isScroolEnd = true;

        clearInterval(that.timer);
        that.timer = null;
      }, 50);
    }


    if (ev) {
      let count = (((this.list.length - 1) * 41) + 55) / this.list.length
      this.index = Math.ceil((ev.target.scrollTop) / count);
      if (this.index == this.list.length) {
      } else {
        this.index = this.index + 1;
      }
    }
    this.list.forEach((e, i) => {
      let span = document.getElementById(this.id + (i + 1));
      if (span) {
        if (i + 1 == this.index) {
          span.className = this.id + "-active";
          // span.scrollIntoView();
          this.scrollElementIntoView(span, 'smooth');
        } else {
          span.className = "passive";
        }
      }
    });

    if (!this.timer2) {
      this.timer2 = setInterval(function () {
        if (!that.timer) {
          var header = document.getElementById('scroll-div-' + that.id);
          header?.scrollTo({
            top: (that.index - 1) * 41,
            behavior: 'smooth'
          });

          clearInterval(that.timer2);
          that.timer2 = null;
        }

      }, 500);
    }
  }

  touchend() {
    var that = this;
    setTimeout(() => {
      var header = document.getElementById('scroll-div-' + that.id);
      header?.scrollTo({
        top: (that.index - 1) * 41,
        behavior: 'smooth'
      });
    }, 500);
  }

  scrollElementIntoView = (element: HTMLElement, behavior?: 'smooth' | 'auto') => {
    return;
    let scrollTop = element.scrollTop

    // Furthermore, if you have for example a header outside the iframe 
    // you need to factor in its dimensions when calculating the position to scroll to
    var header = document.getElementById('scroll-div-' + this.id);
    const headerOutsideIframe = header.clientHeight

    const finalOffset = element.getBoundingClientRect().top + scrollTop + headerOutsideIframe

    header.scrollTo({
      top: finalOffset,
      behavior: behavior || 'auto'
    })
  }
}